export function initRecentlyViewScript() {
    // Recently Viewed Product Storage
    const RECENTLY_VIEW_PRODUCTS_QUEUE_LIMIT = 20;
    let RECENTLY_VIEW_PRODUCTS_QUEUE_VERSION = 1;
    let RECENTLY_VIEW_PRODUCTS_QUEUE = JSON.parse(localStorage.getItem('_rVP')) || [];
    let CURRENT_QUEUE_VERSION = parseInt(localStorage.getItem('_rVPV'));

    // Version Validation
    if (!CURRENT_QUEUE_VERSION || CURRENT_QUEUE_VERSION != RECENTLY_VIEW_PRODUCTS_QUEUE_VERSION) {
        // Delete Old version Data
        localStorage.removeItem('_rVP');
        RECENTLY_VIEW_PRODUCTS_QUEUE = [];
        // Update Version
        localStorage.setItem('_rVPV', RECENTLY_VIEW_PRODUCTS_QUEUE_VERSION);
    }

    let viewedProduct = {
        pdi: $('#js--product-id').val(),
        pna: $('#js--product-name').val(),
        pmi: $('#js--product-img').val()
    };

    let productIndexOnQueue = RECENTLY_VIEW_PRODUCTS_QUEUE.findIndex(product => { return product.pdi == viewedProduct.pdi });

    // Duplication Check
    if (productIndexOnQueue != -1) {
        RECENTLY_VIEW_PRODUCTS_QUEUE.splice(productIndexOnQueue, 1);
    }
    // Queue Overflow Handle
    if (RECENTLY_VIEW_PRODUCTS_QUEUE.length >= RECENTLY_VIEW_PRODUCTS_QUEUE_LIMIT) {
        RECENTLY_VIEW_PRODUCTS_QUEUE.splice(RECENTLY_VIEW_PRODUCTS_QUEUE_LIMIT - 1, 1);
    }

    // Update Queue
    RECENTLY_VIEW_PRODUCTS_QUEUE.unshift(viewedProduct)
    localStorage.setItem('_rVP', JSON.stringify(RECENTLY_VIEW_PRODUCTS_QUEUE));
}